/**
 * Custom-product "Final Product Image" — cart PREVIEW link + thumbnail + Safari-safe download.
 *
 * Hydration: file-upload URLs are often blank in cart Liquid HTML even when
 * /cart.js (and checkout) have them. After every cart refresh we read /cart.js
 * and fill the PREVIEW link + thumbnail for each customizer parent line.
 *
 * Download: Shopify /uploads/ URLs use Content-Disposition: attachment; a plain
 * target=_blank makes Safari tear down the ajax cart. Fetch → blob: download.
 */
(function () {
  if (window.__fndPreviewDownloadInit) return;
  window.__fndPreviewDownloadInit = true;

  var PREVIEW_PROP = "Final Product Image";
  var hydrateTimer = null;

  document.addEventListener("click", function (event) {
    var link = event.target.closest(".fnd-preview-download");
    if (!link) return;

    var src =
      link.getAttribute("data-preview-src") || link.getAttribute("href");
    if (!src || src === "#" || src.indexOf("javascript:") === 0) return;

    event.preventDefault();

    if (link.getAttribute("aria-busy") === "true") return;
    link.setAttribute("aria-busy", "true");

    fetch(src, { credentials: "omit" })
      .then(function (response) {
        if (!response.ok)
          throw new Error("preview fetch failed: " + response.status);
        return response.blob();
      })
      .then(function (blob) {
        var objectUrl = URL.createObjectURL(blob);
        var a = document.createElement("a");
        a.href = objectUrl;
        a.download = "custom-product-preview.png";
        document.body.appendChild(a);
        a.click();
        a.remove();
        setTimeout(function () {
          URL.revokeObjectURL(objectUrl);
        }, 4000);
      })
      .catch(function (error) {
        console.error("[FND] preview download failed", error);
        window.open(src, "_blank", "noopener");
      })
      .then(function () {
        link.removeAttribute("aria-busy");
      });
  });

  function findRowByItemKey(itemKey) {
    var rows = document.querySelectorAll(".cart__item[data-item]");
    for (var i = 0; i < rows.length; i++) {
      if (rows[i].getAttribute("data-item") === itemKey) return rows[i];
    }
    return null;
  }

  function getPreviewUrl(properties) {
    if (!properties) return null;

    var direct = properties[PREVIEW_PROP];
    if (typeof direct === "string" && direct.length > 0) return direct;

    for (var key in properties) {
      if (!Object.prototype.hasOwnProperty.call(properties, key)) continue;
      if (key.charAt(0) === "_") continue;
      var value = properties[key];
      if (typeof value !== "string" || !value) continue;
      if (
        key === PREVIEW_PROP ||
        value.indexOf("/uploads/") !== -1 ||
        (value.indexOf("cdn.shopify") !== -1 &&
          (value.indexOf("http") === 0 || value.indexOf("//") === 0))
      ) {
        // Prefer explicit Final Product Image; otherwise first upload-looking URL
        if (key === PREVIEW_PROP) return value;
        if (!direct && value.indexOf("/uploads/") !== -1) direct = value;
      }
    }
    return typeof direct === "string" && direct ? direct : null;
  }

  /** Bundled Switchboard lines keep the upload on components, not the parent. */
  function getPreviewUrlFromItem(item) {
    if (!item) return null;
    var fromProps = getPreviewUrl(item.properties);
    if (fromProps) return fromProps;

    var components = item.item_components || item.components || [];
    for (var i = 0; i < components.length; i++) {
      var nested = getPreviewUrlFromItem(components[i]);
      if (nested) return nested;
    }
    return null;
  }

  function ensureThumbnail(row, previewUrl, title) {
    var imageContainer = row.querySelector(".cart__item__image");
    if (!imageContainer) return;

    var existing = imageContainer.querySelector(".cart__item__custom-preview");
    if (existing) {
      if (existing.getAttribute("src") !== previewUrl) {
        existing.setAttribute("src", previewUrl);
      }
      imageContainer.classList.remove("image--empty");
      return;
    }

    var anchor = imageContainer.querySelector("a");
    if (!anchor) return;

    imageContainer.classList.remove("image--empty");
    var wrap = document.createElement("div");
    wrap.className = "lazy-image";
    var img = document.createElement("img");
    img.className = "cart__item__custom-preview";
    img.src = previewUrl;
    img.alt = title || "";
    img.width = 90;
    img.height = 90;
    img.loading = "lazy";
    wrap.appendChild(img);
    anchor.innerHTML = "";
    anchor.appendChild(wrap);
  }

  function ensurePreviewLink(row, itemKey, previewUrl) {
    var slot =
      row.querySelector(".cart__item__property--final-preview") ||
      row.querySelector("[data-final-preview-for]");

    if (!slot) {
      var meta = row.querySelector(".cart__item__meta");
      if (!meta) return;
      slot = document.createElement("p");
      slot.className =
        "cart__item__property cart__item__property--final-preview";
      slot.setAttribute("data-final-preview-for", itemKey);
      slot.innerHTML = "<strong>Final Product Image: </strong><span></span>";
      meta.appendChild(slot);
    }

    slot.removeAttribute("hidden");
    slot.hidden = false;

    var span = slot.querySelector("span");
    if (!span) {
      span = document.createElement("span");
      slot.appendChild(span);
    }

    var link = span.querySelector(".fnd-preview-download");
    if (!link) {
      link = document.createElement("a");
      link.className = "fnd-preview-download";
      link.target = "_blank";
      link.rel = "noopener";
      link.textContent = "PREVIEW";
      span.appendChild(link);
    }

    link.href = previewUrl;
    link.setAttribute("data-preview-src", previewUrl);
    link.removeAttribute("data-preview-pending");
  }

  function cartJsUrl() {
    var root =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
      "/";
    return root.replace(/\/?$/, "/") + "cart.js";
  }

  function hydrateFinalPreviews() {
    fetch(cartJsUrl(), { cache: "no-store", credentials: "same-origin" })
      .then(function (response) {
        if (!response.ok) throw new Error("cart.js " + response.status);
        return response.json();
      })
      .then(function (cart) {
        (cart.items || []).forEach(function (item) {
          var previewUrl = getPreviewUrlFromItem(item);
          if (!previewUrl) return;

          var row = findRowByItemKey(item.key);
          if (!row) return;

          // Customizer parent, any line with the preview prop, or a Switchboard
          // bundle (has_components) that carries the image on a nested line.
          var props = item.properties || {};
          var isParent =
            props._main_product != null ||
            props[PREVIEW_PROP] != null ||
            item.has_components ||
            (item.item_components && item.item_components.length);
          if (!isParent && previewUrl.indexOf("/uploads/") === -1) return;

          ensureThumbnail(row, previewUrl, item.product_title || item.title);
          ensurePreviewLink(row, item.key, previewUrl);
        });
      })
      .catch(function (error) {
        console.error("[FND] final preview hydrate failed", error);
      });
  }

  function scheduleHydrate() {
    clearTimeout(hydrateTimer);
    // Cart drawer swaps innerHTML then emits theme:cart:change; Bold may also
    // mutate the DOM a tick later — hydrate twice to land after both.
    hydrateTimer = setTimeout(function () {
      hydrateFinalPreviews();
      setTimeout(hydrateFinalPreviews, 200);
    }, 0);
  }

  document.addEventListener("theme:cart:change", scheduleHydrate);
  document.addEventListener("theme:cart-drawer:show", scheduleHydrate);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scheduleHydrate, {
      once: true,
    });
  } else {
    scheduleHydrate();
  }
})();
